/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */
let artistNumber
const headerOffset = $('.header').height()

export function initialise() {
  $(document).on('ajax.replace', () => {
    setTimeout(() => {
      artistNumber = $('.child-events-artist > section').length
      updateUrl()
      toggleArtists()
    }, 1)
  })
  artistNumber = $('.child-events-artist > section').length
  toggleArtists()
  updateUrl()
}

function updateUrl() {
  const $toggle = $('[data-toggle-schedule-view]')
  $toggle.on('click', function(event) {
    const artistId = $(this).attr('artist')
    // This function is definied inside EventsIndex.js
    if (window.updateEventFilter) {
      window.updateEventFilter(currentFilters => {
        return {
          view: 'schedule',
          artist: artistId,
        }
      })
    }
  })
}

function toggleArtists() {
  let artistNumber = $('.child-events-artist > section').length
  let currentNumber = 20

  if (artistNumber - currentNumber < 3) {
    $('[toggle-more-artists]')
      .show()
      .html('Load ' + (artistNumber - currentNumber) / 2 + ' More Artist')
  } else {
    $('[toggle-more-artists]')
      .show()
      .html('Load ' + (artistNumber - currentNumber) / 2 + ' More Artists')
  }

  $('.child-events-artist > section:lt(' + currentNumber + ')').css({ display: 'block' })
  $('[toggle-more-artists]').on('click', function() {
    $('.child-events-artist > section:lt(' + artistNumber + ')').css({ display: 'block' })
    $('[toggle-more-artists]').hide()
    $('[toggle-less-artists]').show()
  })
  $('[toggle-less-artists]').on('click', function() {
    currentNumber = 20
    scrollUp()
  })
}

function scrollUp() {
  const $linkTarget = $('#search-wrapper')
  console.log($linkTarget.offset().top)

  let position = 0

  if ($linkTarget) {
    position = $linkTarget.offset().top - headerOffset
  } else {
    position = $('#search-wrapper').offset().top - headerOffset
  }

  const scroll = $(window).scrollTop()
  const time = Math.min(Math.abs(scroll - position) / 3, 1500) // distance / 3, or 1.5 seconds max

  $('html, body').animate({ scrollTop: position }, time, 'swing')
}
